// Every "Book" CTA lands on the site's own /book page, preselecting the matching service.
const SERVICE_TO_BOOKING = {
  "wifi-network": "onsite-networking",
  "security-cameras": "onsite-cameras",
  "tv-mounting": "onsite-tv-mounting",
  "smart-home": "onsite-smart-home",
  "home-theater": "onsite-home-theater",
  "it-support": "onsite-computer",
  "business-it": "consult-business-it",
  "yacht-marine": "onsite-marine",
  "sonos-installer-naples": "onsite-home-theater",
  "sonos-installer-fort-myers": "onsite-home-theater",
  "sonos-installer-miami": "onsite-home-theater",
  "unifi-installer-naples": "consult-network-design",
  "unifi-installer-fort-myers": "consult-network-design",
  "business-wifi-naples": "consult-business-it",
  "lutron-installer-naples": "onsite-smart-home",
  "luxury-smart-home-miami": "consult-smart-home-theater",
  "home-theater-miami": "consult-smart-home-theater",
  "tv-mounting-miami": "onsite-tv-mounting",
};

export function bookHref({ campaign, content, service } = {}) {
  const params = new URLSearchParams({ utm_source: "site", utm_medium: "cta" });
  if (campaign) params.set("utm_campaign", campaign);
  if (content) params.set("utm_content", content);
  const slug = service || (campaign || "").replace(/^service-/, "");
  const id = SERVICE_TO_BOOKING[slug] || (service && !slug.includes("/") ? service : "");
  if (id) params.set("service", id);
  return `/book?${params.toString()}`;
}
